export default "﻿<h3>reCAPTCHA</h3>\n<br />\n<a href=\"https://developers.google.com/recaptcha/docs/display\">reCAPTCHA v2</a>"